import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
	},
});

const TopClassesLogErrors = ({ data }) => {
	return (
		<DataGrid
			autoHeight={false}
			style={{ background: "white" }}
			rows={Object.keys(data).reduce((i, c) => {
				i.push({
					logger: c,
					value: data[c],
				});
				return i;
			}, [])}
			density="compact"
			autoPageSize={true}
			disableColumnFilter={true}
			disableColumnMenu={true}
			disableColumnSelector={true}
			disableDensitySelector={true}
			disableSelectionOnClick={true}
			columns={[
				{
					field: "logger",
					headerName: "Logger",
					flex: 1,
					sortable: false,
					headerAlign: "left",
					align: "left",
					renderCell: ({ row }) => (
						<CustomWidthTooltip title={row.logger}>
							<div style={{ width: "100%" }}>{row.logger.substring(row.logger.lastIndexOf(".") + 1)}</div>
						</CustomWidthTooltip>
					),
				},
				{
					field: "value",
					headerName: "Count",
					width: 80,
					sortable: false,
					headerAlign: "center",
					align: "center",
				},
			]}
			pageSize={5}
			rowsPerPageOptions={[5]}
			getRowId={(row) => row.logger}
		></DataGrid>
	);
};

export default TopClassesLogErrors;
